import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setTabActive,
  setRedirectedWorkspace,
  setUserSearchTerm,
} from "slices/systemAdmin/systemAdminSlice";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import UsersHeader from "layout/systemAdmin/users/UsersHeader";
import UsersFilter from "layout/systemAdmin/users/UsersFilter";
import UsersContentBody from "layout/systemAdmin/users/UsersContentBody";
import UsersCreate from "layout/systemAdmin/users/UsersCreate";
import { fetchUsers } from "slices/systemAdmin/actions/users";
import { fetchAuthentication } from "slices/systemAdmin/actions/authentication";

const UsersContent = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.systemAdmin?.usersInfo);
  useEffect(() => {
    dispatch(setTabActive(1));
    dispatch(hideModal(modalTypes.ADD_USER_TO_WORKSPACE));
    dispatch(setUserSearchTerm(""));
    dispatch(fetchAuthentication());
    dispatch(fetchUsers());
    dispatch(setRedirectedWorkspace(""));
  }, [dispatch]);

  const getInfoMessage = () => {
    const multiUsers = [];

    userInfo?.users?.forEach((user) => {
      if (user.workspaces?.length > 1) {
        multiUsers.push(user.username);
      }
    });

    return multiUsers.length !== 0
      ? `There are ${userInfo?.licensedUsers} licensed users. ${
          multiUsers.length
        } of these ${
          multiUsers.length === 1 ? "is" : "are"
        } multi-workspace user${
          multiUsers.length === 1 ? "" : "s"
        } and will only take one license.`
      : undefined;
  };

  return (
    <>
      <UsersHeader
        licenseCount={userInfo?.licenseCount}
        licensedUsers={userInfo?.licensedUsers}
        info={getInfoMessage()}
      />
      <div className="users__filter__container">
        <UsersFilter />
      </div>
      <div className="users__container">
        <UsersContentBody users={userInfo?.users} />
      </div>
      <UsersCreate />
    </>
  );
};

export default UsersContent;
